import { assetsPath } from "../../../utils";

const baseAssetUrl = assetsPath("phuket-laguna-park-2");
const maps = `${baseAssetUrl}/images/site-plan/image.jpg`;

const type = [
  {
    value: "all",
    title: {
      en: "ALL",
      ru: "ВСЕ",
      cn: "全部户型",
    },
  },
  {
    value: "two-bedroom",
    title: {
      en: "2 BEDROOM",
      ru: "2 СПАЛЬНИ",
      cn: "2间卧室",
    },
  },
  {
    value: "three-bedroom",
    title: {
      en: "3 BEDROOM",
      ru: "3 СПАЛЬНИ",
      cn: "3间卧室",
    },
  },
];

export default {
  maps,
  type,
};



// WEBPACK FOOTER //
// ./src/data/PhuketDusitDeluxePoolVilla/sitePlan/index.js